import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { ProblemClassModel } from '../../features/region-problems/utils/models/problemClassModel'
import { ProblemModel } from '../../features/region-problems/utils/models/problemModel'
import { ProblemTypeModel } from '../../features/region-problems/utils/models/problemTypeModel'
import { sliceNames } from '../../utils/constants/sliceNames'

const initialState: {
  problemClassModalData: {
    visible: boolean
    data?: Omit<ProblemClassModel, 'problem_types'>
  }
  problemTypeModalData: {
    visible: boolean
    data?: Omit<ProblemTypeModel, 'problems'>
    classId?: number
  }
  problemModalData: {
    visible: boolean
    data?: ProblemModel
    typeId?: number
  }
} = {
  problemClassModalData: {
    visible: false,
  },
  problemTypeModalData: {
    visible: false,
  },
  problemModalData: {
    visible: false,
  },
}

const regionProblemReducer = createSlice({
  name: sliceNames.REGION_PROBLEM,
  initialState,
  reducers: {
    setProblemClassModalData: (
      state,
      action: PayloadAction<{
        visible: boolean
        data?: Omit<ProblemClassModel, 'problem_types'>
      }>
    ) => {
      state.problemClassModalData = action.payload
    },
    setProblemTypeModalData: (
      state,
      action: PayloadAction<{
        visible: boolean
        data?: Omit<ProblemTypeModel, 'problems'>
        classId?: number
      }>
    ) => {
      state.problemTypeModalData = action.payload
    },
    setProblemModalData: (
      state,
      action: PayloadAction<{
        visible: boolean
        data?: ProblemModel
        typeId?: number
      }>
    ) => {
      state.problemModalData = action.payload
    },
  },
})

export default regionProblemReducer.reducer
export const regionProblemReducerActions = regionProblemReducer.actions
